module.exports = __webpack_public_path__ + "img/3.31bf09d6.png";